(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sticky-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mf-sticky-product-details')) {
    customElements.define('mf-sticky-product-details', class extends HTMLElement {
      connectedCallback() {
        this.desktopQuery = window.matchMedia('(min-width: 1000px)');
        this.priceTarget = this.querySelector('[data-sticky-product-prices]');
        this.priceSource = this.closest('.shopify-section')?.querySelector('.product__info .product-meta__price-list-container');
        this.updatePrice = () => {
          if (this.priceSource && this.priceTarget.innerHTML !== this.priceSource.innerHTML) {
            this.priceTarget.innerHTML = this.priceSource.innerHTML;
          }
        };
        this.priceObserver = new MutationObserver(this.updatePrice);
        this.updateDesktop = () => {
          this.priceObserver.disconnect();
          if (this.desktopQuery.matches && this.priceSource) {
            this.updatePrice();
            this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true, attributes: true });
          }
        };
        this.desktopQuery.addEventListener('change', this.updateDesktop);
        this.updateDesktop();
      }
      disconnectedCallback() {
        this.priceObserver?.disconnect();
        this.desktopQuery?.removeEventListener('change', this.updateDesktop);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
